<template>
    <!-- <div class="container">
      <div class="father">
        <div class="left">
          <div class="header">
            更改密码
          </div>
          <div style="
          font-size: calc(18vw * 100 / 1920);
          text-align: center;
          margin-top: 4%;
          "
          >Please enter <span style="color:#5099a5;
                                     font-weight: bold;
          ">the old password</span> and enter the <span style="
          color:#5099a5;
          font-weight: bold;
          "
          >new password</span></div>
          <div style="
          font-size: calc(18vw * 100 / 1920);
          text-align: center;
          "
          >to change the password！</div>
          <div style="
          margin-left: 15%;
          margin-top: 10%;
          font-weight: bold;
          font-size: calc(18vw * 100 / 1920);
          ">所属公司       <span
          style="color:#0c3483;
          margin-left: 3%;
          font-weight: 1000;
          "
          >{{ this.company }}</span></div>

          <div class="form-wrapper">
          <el-form :model="ruleForm" ref="ruleForm" status-icon :rules="rules"  label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户名" prop="name">
          <el-input :disabled="true" v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="原始密码" prop="orPasswordpass">
              <el-input type="password" v-model="ruleForm.orPasswordpass"  placeholder="请输入旧密码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
              <el-input type="password" v-model="ruleForm.pass" placeholder="请输入新密码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入新密码" autocomplete="off"></el-input>
          </el-form-item>          
          <el-form-item>
              <el-button class="btn" @click="submitForm('ruleForm')">提交</el-button>
              <el-button class="btn btn1" @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
          </el-form>
        </div>
        </div> 
        <div class="right">
          <!-- <el-button class="btn btn2" @click="login">重新登录</el-button> -->
    <!-- </div>
      </div>
      </div>  -->
    <div class="container">
        <div class='box'>
            <div class='box-form'>
                <div class='box-login-tab'></div>
                <div class='box-login-title'>
                    <div class='i i-login'></div>
                    <h2>CHANGE PASSWORD</h2>
                </div>
                <div class='box-login'>
                    <el-form :model="ruleForm" ref="ruleForm" status-icon :rules="rules" class="demo-ruleForm">
                        <div class='fieldset-body' id='login_form'>
                            <button onclick="openLoginInfo();" class='b b-form i i-more'
                                title='Mais Informações'></button>
                            <h1>ESMT调度台</h1>
                            <p class='field'>
                                <label for='user'>所属公司</label>
                                <input type="text" class="input-item" disabled v-model="company" @keyup.enter="login">
                            </p>
                            <p class='field'>
                                <label for='user'>用户名</label>
                                <el-form-item prop="name">
                                    <el-input :disabled="true" v-model="ruleForm.name"></el-input>
                                </el-form-item>
                                <!-- <label for='user'>用户名</label>
                            <input type="text" name="username" placeholder="username" id='user' title='Username'
                                class="input-item" v-model="loginForm.name" @keyup.enter="login">
                            <!-- <input type='text' id='user' name='user' title='Username' /> -->
                                <!-- <span id='valida' class='i i-warning'></span>  -->
                            </p>
                            <p class='field'>
                                <label for='user'>原始密码</label>
                                <el-form-item prop="orPasswordpass">
                                    <el-input type="password" v-model="ruleForm.orPasswordpass" placeholder="请输入旧密码"
                                        autocomplete="off"></el-input>
                                </el-form-item>
                                <!-- <label for='user'>用户名</label>
                            <input type="text" name="username" placeholder="username" id='user' title='Username'
                                class="input-item" v-model="loginForm.name" @keyup.enter="login">
                            <!-- <input type='text' id='user' name='user' title='Username' /> -->
                                <!-- <span id='valida' class='i i-warning'></span>  -->
                            </p>
                            <p class='field'>
                                <label for='pass'>密码</label>
                                <el-form-item prop="pass">
                                    <el-input type="password" v-model="ruleForm.pass" placeholder="请输入新密码"
                                        autocomplete="off"></el-input>
                                </el-form-item>
                                <!-- <input type="password" name="password" id='pass' placeholder="Password" class="input-item"
                                v-model="loginForm.pwd" @keyup.enter="login"> -->
                                <!-- <input type='password' id='pass' name='pass' title='Password' /> -->
                                <!-- <span id='valida' class='i i-close'></span> -->
                            </p>
                            <p class='field'>
                                <label for='pass'>确认密码</label>
                                <el-form-item prop="checkPass">
                                    <el-input type="password" v-model="ruleForm.checkPass" placeholder="请再次输入新密码"
                                        autocomplete="off"></el-input>
                                </el-form-item>
                                <!-- <input type="password" name="password" id='pass' placeholder="Password" class="input-item"
                                v-model="loginForm.pwd" @keyup.enter="login"> -->
                                <!-- <input type='password' id='pass' name='pass' title='Password' /> -->
                                <!-- <span id='valida' class='i i-close'></span> -->
                            </p>

                            <label class='checkbox'>
                                <!-- <input type='submit'  title='Keep me Signed in' />  -->
                                <!-- <span @click="change" style="margin-right: 2vw;"><a href="#">修改密码</a></span> -->
                                <span @click="login"><a href="#">重新登录</a></span>
                            </label>
                            <div>
                                <input type='submit' @click="submitForm('ruleForm')" id='do_login' value='提交'
                                    title='Get Started' />
                                <input type='reset' @click="resetForm('ruleForm')" id='do_login' value='重置'
                                    title='Get Started' />
                            </div>

                        </div>
                    </el-form>
                </div>
            </div>
            <div class='box-info'>
                <p><button onclick="closeLoginInfo();" class='b b-info i i-left' title='Back to Sign In'></button>
                <h3>Need Help?</h3>
                </p>
                <div class='line-wh'></div>
                <button onclick="" class='b-support' title='Forgot Password?'> Forgot Password?</button>
                <button onclick="" class='b-support' title='Contact Support'> Contact Support</button>
                <div class='line-wh'></div>
                <button onclick="" class='b-cta' title='Sign up now!'> CREATE ACCOUNT</button>
            </div>
        </div>
    </div>
</template>

<script>
import App from '../../App'
import req from '../../utils/index'
import url1 from '../../config/url1'
import { onDeactivated } from 'vue';
export default {
    data() {
        var checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户名不能为空'));
            }
            else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            else {
                if (this.ruleForm.checkPass == '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            else {
                if (this.ruleForm.orPasswordpass == '') {
                    this.$refs.ruleForm.validateField('orPasswordpass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            }
            else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            }
            else {
                callback();
            }
        };
        return {
            email: '',
            password: '',
            keepSignedIn: false,
            emailIconClass: '',
            emailIconDisplay: 'none',
            passwordIconClass: '',
            passwordIconDisplay: 'none',
            boxFormLeft: '0px',
            boxInfoRight: '-5px',
            isLoginInfoOpen: false,

            loginForm: {
                name: '',
                pwd: ''
            },
            company: '',
            ruleForm: {
                name: '',
                orPasswordpass: '',
                pass: '',
                checkPass: '',
            },
            rules: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                name: [
                    { validator: checkName, trigger: 'blur' }
                ],
                orPasswordpass: [
                    { validator: validatePass1, trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        this.getName();
    },
    methods: {
        // 登录逻辑
        doLogin() {
            this.closeLoginInfo();
            this.resetIcons();

            let proceed = true;

            if (!this.email.trim()) {
                this.emailIconClass = 'i-warning';
                this.emailIconDisplay = 'block';
                proceed = false;
            }

            if (!this.password.trim()) {
                this.passwordIconClass = 'i-warning';
                this.passwordIconDisplay = 'block';
                proceed = false;
            }

            if (proceed) {
                this.emailIconClass = 'i-save';
                this.emailIconDisplay = 'block';
                this.passwordIconClass = 'i-save';
                this.passwordIconDisplay = 'block';
            }
        },
        // 重置图标状态
        resetIcons() {
            this.emailIconClass = '';
            this.emailIconDisplay = 'none';
            this.passwordIconClass = '';
            this.passwordIconDisplay = 'none';
        },
        // 打开登录信息
        openLoginInfo() {
            this.isLoginInfoOpen = true;
            this.updateLoginInfoStyles();
        },
        // 关闭登录信息
        closeLoginInfo() {
            this.isLoginInfoOpen = false;
            this.updateLoginInfoStyles();
        },
        // 更新登录信息样式
        updateLoginInfoStyles() {
            this.boxFormLeft = this.isLoginInfoOpen ? '-37%' : '0px';
            this.boxInfoRight = this.isLoginInfoOpen ? '-37%' : '-5px';
        },
        // login() {
        //     let URL = `${url1.login}?name=${this.loginForm.name}&pwd=${this.loginForm.pwd}&type=PC`;
        //     req.post(URL).then(res => {
        //         if (res.data.code === 200) {
        //             // alert('登录成功！')
        //             const token = res.data.data.token;
        //             const name = res.data.data.name;
        //             const phone = res.data.data.phone;
        //             const address = res.data.data.address;
        //             const company = res.data.data.company;
        //             localStorage.setItem('token', token);
        //             localStorage.setItem('name', name);
        //             localStorage.setItem('phone', phone);
        //             localStorage.setItem('address', address);
        //             localStorage.setItem('company', company);
        //             this.$router.push({ name: 'home' });
        //         } else {
        //             alert(res.data.message)
        //         }

        //     })
        //     // .catch(error =>{
        //     //     alert(res.data.message)
        //     // })

        // },
        change() {
            localStorage.clear();
            this.$router.push('/changePWD');
        },
        // 重新登录
        login() {
            localStorage.clear();
            this.$router.push('/login');
        },
        // 获取用户名
        getName() {
            const value = localStorage.getItem('name');
            const value1 = localStorage.getItem('company');
            this.ruleForm.name = value;
            this.company = value1;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.changePassword();
                }
                else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changePassword() {
            let URL = `${url1.changePwd}?name=${this.ruleForm.name}&oldPwd=${this.ruleForm.orPasswordpass}&newPwd=${this.ruleForm.checkPass}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    alert('修改密码成功！请重新登录');
                    localStorage.removeItem('token');
                    localStorage.clear();
                    //跳转到首页
                    this.$router.push("/login");
                }
                else {
                    alert(res.data.message);
                    localStorage.removeItem('token');
                    localStorage.clear();
                    // this.$router.push("/login");
                }
            });
        },
    },
    components: {
        App, onDeactivated
    }
}
</script>

<style lang="less" scoped>
@import 'https://fonts.googleapis.com/css?family=Open+Sans|Quicksand:400,700';

/*--------------------
General Style
---------------------*/
*,
*::before,
*::after {
    box-sizing: border-box;
}
.container {
    height: 100%;
    width: 100%;
    background: rgba(30, 29, 31, 1);
    background: -moz-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(30, 29, 31, 1)), color-stop(100%, rgba(223, 64, 90, 1)));
    background: -webkit-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -o-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -ms-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: linear-gradient(135deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#1e1d1f', endColorstr='#df405a', GradientType=1);}
body,
html {
    height: 100%;
    font-family: 'Quicksand', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

}

body {
    background: rgba(30, 29, 31, 1);
    background: -moz-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(30, 29, 31, 1)), color-stop(100%, rgba(223, 64, 90, 1)));
    background: -webkit-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -o-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: -ms-linear-gradient(-45deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    background: linear-gradient(135deg, rgba(30, 29, 31, 1) 0%, rgba(223, 64, 90, 1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#1e1d1f', endColorstr='#df405a', GradientType=1);
}

/*--------------------
Text
---------------------*/

h2,
h3 {
    font-size: 16px;
    letter-spacing: -1px;
    line-height: 20px;
}

h2 {
    color: #747474;
    text-align: center;
}

h3 {
    color: #032942;
    text-align: right;
}

/*--------------------
Icons
---------------------*/
.i {
    width: 20px;
    height: 20px;
}

.i-login {
    margin: 13px 0px 0px 15px;
    position: relative;
    float: left;
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDQxNi4yMjkgNDE2LjIyOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDE2LjIyOSA0MTYuMjI5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQwMy43MjksMjkuNjVINzEuODAyYy02LjkwMywwLTEyLjUsNS41OTctMTIuNSwxMi41djg2LjM2M2MwLDYuOTAzLDUuNTk3LDEyLjUsMTIuNSwxMi41czEyLjUtNS41OTcsMTIuNS0xMi41VjU0LjY1ICAgIGgzMDYuOTI3djMwNi45MjhIODQuMzAydi03My44NjFjMC02LjkwMy01LjU5Ny0xMi41LTEyLjUtMTIuNXMtMTIuNSw1LjU5Ny0xMi41LDEyLjV2ODYuMzYxYzAsNi45MDMsNS41OTcsMTIuNSwxMi41LDEyLjUgICAgaDMzMS45MjdjNi45MDIsMCwxMi41LTUuNTk3LDEyLjUtMTIuNVY0Mi4xNUM0MTYuMjI5LDM1LjI0Nyw0MTAuNjMxLDI5LjY1LDQwMy43MjksMjkuNjV6IiBmaWxsPSIjODczMTRlIi8+CgkJPHBhdGggZD0iTTE4NS40MTcsMjg3LjgxMWMwLDUuMDU3LDMuMDQ1LDkuNjEzLDcuNzE2LDExLjU1YzEuNTQ3LDAuNjQyLDMuMTcsMC45NSw0Ljc4MSwwLjk1YzMuMjUzLDAsNi40NTEtMS4yNyw4Ljg0Mi0zLjY2ICAgIGw3OS42OTctNzkuNjk3YzIuMzQ0LTIuMzQ0LDMuNjYtNS41MjMsMy42Ni04LjgzOWMwLTMuMzE2LTEuMzE2LTYuNDk1LTMuNjYtOC44MzlsLTc5LjY5Ny03OS42OTcgICAgYy0zLjU3NS0zLjU3NS04Ljk1MS00LjY0Ni0xMy42MjMtMi43MWMtNC42NzEsMS45MzYtNy43MTYsNi40OTMtNy43MTYsMTEuNTQ5djY3LjE5N0gxMi41Yy02LjkwMywwLTEyLjUsNS41OTctMTIuNSwxMi41ICAgIGMwLDYuOTAzLDUuNTk3LDEyLjUsMTIuNSwxMi41aDE3Mi45MTdWMjg3LjgxMUwxODUuNDE3LDI4Ny44MTF6IE0yMTAuNDE3LDE1OC41OTRsNDkuNTIxLDQ5LjUybC00OS41MjEsNDkuNTIxVjE1OC41OTR6IiBmaWxsPSIjODczMTRlIi8+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
    background-size: 18px 18px;
    background-repeat: no-repeat;
    background-position: center;
}

.i-more {
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDYxMiA2MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA2MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0ibW9yZSI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik03Ni41LDIyOS41QzM0LjMsMjI5LjUsMCwyNjMuOCwwLDMwNnMzNC4zLDc2LjUsNzYuNSw3Ni41UzE1MywzNDguMiwxNTMsMzA2UzExOC43LDIyOS41LDc2LjUsMjI5LjV6IE03Ni41LDM0NC4yICAgICBjLTIxLjEsMC0zOC4yLTE3LjEwMS0zOC4yLTM4LjJjMC0yMS4xLDE3LjEtMzguMiwzOC4yLTM4LjJzMzguMiwxNy4xLDM4LjIsMzguMkMxMTQuNywzMjcuMSw5Ny42LDM0NC4yLDc2LjUsMzQ0LjJ6ICAgICAgTTUzNS41LDIyOS41Yy00Mi4yLDAtNzYuNSwzNC4zLTc2LjUsNzYuNXMzNC4zLDc2LjUsNzYuNSw3Ni41UzYxMiwzNDguMiw2MTIsMzA2UzU3Ny43LDIyOS41LDUzNS41LDIyOS41eiBNNTM1LjUsMzQ0LjIgICAgIGMtMjEuMSwwLTM4LjItMTcuMTAxLTM4LjItMzguMmMwLTIxLjEsMTcuMTAxLTM4LjIsMzguMi0zOC4yczM4LjIsMTcuMSwzOC4yLDM4LjJDNTczLjcsMzI3LjEsNTU2LjYsMzQ0LjIsNTM1LjUsMzQ0LjJ6ICAgICAgTTMwNiwyMjkuNWMtNDIuMiwwLTc2LjUsMzQuMy03Ni41LDc2LjVzMzQuMyw3Ni41LDc2LjUsNzYuNXM3Ni41LTM0LjMsNzYuNS03Ni41UzM0OC4yLDIyOS41LDMwNiwyMjkuNXogTTMwNiwzNDQuMiAgICAgYy0yMS4xLDAtMzguMi0xNy4xMDEtMzguMi0zOC4yYzAtMjEuMSwxNy4xLTM4LjIsMzguMi0zOC4yYzIxLjEsMCwzOC4yLDE3LjEsMzguMiwzOC4yQzM0NC4yLDMyNy4xLDMyNy4xLDM0NC4yLDMwNiwzNDQuMnoiIGZpbGw9IiNkZjQwNWEiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
}

.i-save {
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDYxMiA2MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYxMiA2MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8ZyBpZD0idGljayI+CgkJPGc+CgkJCTxwYXRoIGQ9Ik00MzYuNywxOTYuNzAxTDI1OC4xODgsMzc1LjIxM2wtODIuODY5LTgyLjg4N2MtNy4yODctNy4yODctMTkuMTI1LTcuMjg3LTI2LjQxMiwwcy03LjI4NywxOS4xMjUsMCwyNi40MTIgICAgIGw5My44MDgsOTMuODA4YzAuNjMxLDAuODk5LDEuMDE0LDEuOTMyLDEuODE3LDIuNzM1YzMuNzY4LDMuNzY4LDguNzIxLDUuNTA4LDEzLjY1NSw1LjM3NGM0LjkzNCwwLjExNSw5LjkwNy0xLjYwNiwxMy42NzQtNS4zNzQgICAgIGMwLjgwMy0wLjgwNCwxLjE4Ni0xLjgzNiwxLjgxNy0yLjczNWwxODkuNDM0LTE4OS40MzNjNy4yODYtNy4yODcsNy4yODYtMTkuMTI1LDAtMjYuNDEyICAgICBDNDU1LjgwNiwxODkuNDE0LDQ0My45ODcsMTg5LjQxNCw0MzYuNywxOTYuNzAxeiBNMzA2LDBDMTM2Ljk5MiwwLDAsMTM2Ljk5MiwwLDMwNnMxMzYuOTkyLDMwNiwzMDYsMzA2ICAgICBjMTY4Ljk4OCwwLDMwNi0xMzYuOTkyLDMwNi0zMDZTNDc1LjAwOCwwLDMwNiwweiBNMzA2LDU3My43NUMxNTguMTI1LDU3My43NSwzOC4yNSw0NTMuODc1LDM4LjI1LDMwNiAgICAgQzM4LjI1LDE1OC4xMjUsMTU4LjEyNSwzOC4yNSwzMDYsMzguMjVjMTQ3Ljg3NSwwLDI2Ny43NSwxMTkuODc1LDI2Ny43NSwyNjcuNzVDNTczLjc1LDQ1My44NzUsNDUzLjg3NSw1NzMuNzUsMzA2LDU3My43NXoiIGZpbGw9IiMyMGMxOTgiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
}

.i-warning {
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTguMS4xLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDYxMi44MTYgNjEyLjgxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjEyLjgxNiA2MTIuODE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCI+CjxnPgoJPHBhdGggZD0iTTMwNi40MDgsMEMxMzcuMzY4LDAsMC4zNzEsMTM2Ljk5NywwLjM3MSwzMDYuMDM3czEzNi45OTcsMzA2Ljc3OSwzMDYuMDM3LDMwNi43NzlzMzA2LjAzNy0xMzcuODEzLDMwNi4wMzctMzA2LjAzNyAgIEM2MTIuNDQ1LDEzNy43MzksNDc1LjQ0OCwwLDMwNi40MDgsMHogTTMwNi40MDgsNTgzLjE0N2MtMTUyLjIwMywwLTI3Ni4zNjgtMTI0LjE2NS0yNzYuMzY4LTI3Ni4zNjggICBTMTU0LjIwNSwyOS41OTUsMzA2LjQwOCwyOS41OTVTNTgyLjc3NiwxNTMuNzYsNTgyLjc3NiwzMDYuNzc5UzQ1OC42MTEsNTgzLjE0NywzMDYuNDA4LDU4My4xNDd6IE0zMjEuNjEzLDQzMS43NiAgIGMwLDguODI3LTcuMTk1LDE2LjAyMS0xNi4wMjEsMTYuMDIxYy04LjgyNywwLTE2LjAyMS03LjE5NS0xNi4wMjEtMTYuMDIxYzAtOC44MjcsNy4xOTUtMTYuMDIxLDE2LjAyMS0xNi4wMjEgICBTMzIxLjYxMyw0MjIuOTM0LDMyMS42MTMsNDMxLjc2eiBNMjkwLjM4NywzNTMuMjExdi0xODAuMjRjMC04LjAxMSw2LjM3OS0xNC4zOSwxNC4zOS0xNC4zOWM4LjAxMSwwLDE0LjM5LDYuMzc5LDE0LjM5LDE0LjM5ICAgdjE4MC4yNGMwLDguMDExLTYuMzc5LDE0LjM5LTE0LjM5LDE0LjM5QzI5Ni43NjYsMzY4LjQ5MSwyOTAuMzg3LDM2MS4yMjIsMjkwLjM4NywzNTMuMjExeiIgZmlsbD0iI2Y1ZDg3OCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
}

.i-close {
    background-image: url(data:image/svg+xml;utf8;base64,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);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
}

.i-left {
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDQxNC4yOTggNDE0LjI5OSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDE0LjI5OCA0MTQuMjk5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTMuNjYzLDQxMC42MzdjMi40NDEsMi40NCw1LjY0LDMuNjYxLDguODM5LDMuNjYxYzMuMTk5LDAsNi4zOTgtMS4yMjEsOC44MzktMy42NjFsMTg1LjgwOS0xODUuODFsMTg1LjgxLDE4NS44MTEgICBjMi40NCwyLjQ0LDUuNjQxLDMuNjYxLDguODQsMy42NjFjMy4xOTgsMCw2LjM5Ny0xLjIyMSw4LjgzOS0zLjY2MWM0Ljg4MS00Ljg4MSw0Ljg4MS0xMi43OTYsMC0xNy42NzlsLTE4NS44MTEtMTg1LjgxICAgbDE4NS44MTEtMTg1LjgxYzQuODgxLTQuODgyLDQuODgxLTEyLjc5NiwwLTE3LjY3OGMtNC44ODItNC44ODItMTIuNzk2LTQuODgyLTE3LjY3OSwwbC0xODUuODEsMTg1LjgxTDIxLjM0LDMuNjYzICAgYy00Ljg4Mi00Ljg4Mi0xMi43OTYtNC44ODItMTcuNjc4LDBjLTQuODgyLDQuODgxLTQuODgyLDEyLjc5NiwwLDE3LjY3OGwxODUuODEsMTg1LjgwOUwzLjY2MywzOTIuOTU5ICAgQy0xLjIxOSwzOTcuODQxLTEuMjE5LDQwNS43NTYsMy42NjMsNDEwLjYzN3oiIGZpbGw9IiM4NzMxNGUiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: center;
}

/*--------------------
Login Box
---------------------*/

.box {
    width: 600px;
    position: absolute;
    top: 50%;
    left: 50%;

    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

.box-form {
    width: 590px;
    position: relative;
    z-index: 1;
}

.box-login-tab {
    width: 50%;
    height: 40px;
    background: #fdfdfd;
    position: relative;
    float: left;
    z-index: 1;

    -webkit-border-radius: 6px 6px 0 0;
    -moz-border-radius: 6px 6px 0 0;
    border-radius: 6px 6px 0 0;

    -webkit-transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
    transform: perspective(5px) rotateX(0.93deg) translateZ(-1px);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    -webkit-box-shadow: 15px -15px 30px rgba(0, 0, 0, 0.32);
    -moz-box-shadow: 15px -15px 30px rgba(0, 0, 0, 0.32);
    box-shadow: 15px -15px 30px rgba(0, 0, 0, 0.32);
}

.box-login-title {
    width: 35%;
    height: 40px;
    position: absolute;
    float: left;
    z-index: 2;
}

.box-login {
    position: relative;
    top: -4px;
    width: 590px;
    background: #fdfdfd;
    text-align: center;
    overflow: hidden;
    z-index: 2;

    -webkit-border-top-right-radius: 6px;
    -webkit-border-bottom-left-radius: 6px;
    -webkit-border-bottom-right-radius: 6px;
    -moz-border-radius-topright: 6px;
    -moz-border-radius-bottomleft: 6px;
    -moz-border-radius-bottomright: 6px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;

    -webkit-box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
    -moz-box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
    box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
}

.box-info {
    width: 260px;
    top: 60px;
    height: 500px;
    position: absolute;
    right: -5px;
    padding: 15px 15px 15px 30px;
    background-color: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.2);
    z-index: 0;

    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;

    -webkit-box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
    -moz-box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
    box-shadow: 15px 30px 30px rgba(0, 0, 0, 0.32);
}

.line-wh {
    width: 100%;
    height: 1px;
    top: 0px;
    margin: 12px auto;
    position: relative;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
}

/*--------------------
Form
---------------------*/

a {
    text-decoration: none;
}

button:focus {
    outline: 0;
}

.b {
    height: 24px;
    line-height: 24px;
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.b-form {
    opacity: 0.5;
    margin: 10px 20px;
    float: right;
}

.b-info {
    opacity: 0.5;
    float: left;
}

.b-form:hover,
.b-info:hover {
    opacity: 1;
}

.b-support,
.b-cta {
    width: 100%;
    padding: 0px 15px;
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    letter-spacing: -1px;
    font-size: 16px;
    line-height: 32px;
    cursor: pointer;

    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    border-radius: 16px;
}

.b-support {
    border: #87314e 1px solid;
    background-color: transparent;
    color: #87314e;
    margin: 6px 0;
}

.b-cta {
    border: #df405a 1px solid;
    background-color: #df405a;
    color: #fff;
}

.b-support:hover,
.b-cta:hover {
    color: #fff;
    background-color: #87314e;
    border: #87314e 1px solid;
}

.fieldset-body {
    display: table;
}

.fieldset-body p {
    width: 100%;
    display: inline-table;
    padding: 0px 20px;
    margin-bottom: 2px;
}

label {
    float: left;
    width: 100%;
    top: 0px;
    color: #032942;
    font-size: 13px;
    font-weight: 700;
    text-align: left;
    line-height: 1.5;
}

label.checkbox {
    float: left;
    padding: 5px 20px;
    line-height: 1.7;
}

input[type=text],
input[type=password] {
    width: 100%;
    height: 32px;
    padding: 0px 10px;
    background-color: rgba(0, 0, 0, 0.03);
    border: none;
    display: inline;
    color: #303030;
    font-size: 16px;
    font-weight: 400;
    float: left;

    -webkit-box-shadow: inset 1px 1px 0px rgba(0, 0, 0, 0.05), 1px 1px 0px rgba(255, 255, 255, 1);
    -moz-box-shadow: inset 1px 1px 0px rgba(0, 0, 0, 0.05), 1px 1px 0px rgba(255, 255, 255, 1);
    box-shadow: inset 1px 1px 0px rgba(0, 0, 0, 0.05), 1px 1px 0px rgba(255, 255, 255, 1);
}

input[type=text]:focus,
input[type=password]:focus {
    background-color: #f8f8c6;
    outline: none;
}

input[type=submit] {
    width: 100%;
    height: 48px;
    margin-top: 24px;
    padding: 0px 20px;
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    background-color: #87314e;
    border: 1px #87314e solid;
    opacity: 1;
    cursor: pointer;
}

input[type=reset] {
    width: 100%;
    height: 48px;
    // margin-top: 24px;
    padding: 0px 20px;
    font-family: 'Quicksand', sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    background-color: #a8204e;
    border: 1px #a8204e solid;
    opacity: 1;
    cursor: pointer;
}

input[type=reset]:hover {
    background-color: #e97387;
    border: 1px #e97387 solid;
}

input[type=reset]:focus {
    outline: none;
}

input[type=submit]:hover {
    background-color: #df405a;
    border: 1px #df405a solid;
}

input[type=submit]:focus {
    outline: none;
}

p.field span.i {
    width: 24px;
    height: 24px;
    float: right;
    position: relative;
    margin-top: -26px;
    right: 2px;
    z-index: 2;
    display: none;

    -webkit-animation: bounceIn 0.6s linear;
    -moz-animation: bounceIn 0.6s linear;
    -o-animation: bounceIn 0.6s linear;
    animation: bounceIn 0.6s linear;
}

/*--------------------
Transitions
---------------------*/

.box-form,
.box-info,
.b,
.b-support,
.b-cta,
input[type=submit],
p.field span.i {

    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
}

/*--------------------
Credits
---------------------*/

.icon-credits {
    width: 100%;
    position: absolute;
    bottom: 4px;
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.1);
    text-align: center;
    z-index: -1;
}

.icon-credits a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.2);
}

.el-form-item {
    margin-bottom: 0px;
}

/deep/ .el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    /* padding-top: 4px; */
    position: absolute;
    top: 78%;
    left: 0;
}

/deep/ .el-input.is-disabled .el-input__inner {
    background-color: #f5f5f5;
    color: inherit;
    /* 让字体颜色继承父元素的字体颜色，相当于去掉单独设置的字体颜色 */
}


// .container {
//     background-image: url(../../assets/images/background.jpg);
//     background-repeat: no-repeat;
//     background-size: cover;
//     width: 100vw;
//     height: 100vh;
//     position: relative;
// }

// .father {
//     position: absolute;
//     left: 22%;
//     top: 15%;
//     display: flex;
//     width: 58%;
//     height: 70%;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
// }

// .right {
//     background-image: url(../../assets/images/right.png);
//     background-size: cover;
//     border-radius: 0 10px 10px 0;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
//     width: 100%;
// }

// .left {
//     position: relative;
//     background-color: rgba(252, 253, 253, 0.938);
//     border-radius: 10px 0 0 10px;
//     box-shadow: rgba(0, 0, 0, 0.4) 0px 30px 90px;
//     width: 100%;
// }

// .header {
//     font-size: calc(50vw * 100 / 1920);
//     margin-top: 8%;
//     font-weight: 700;
//     color: #010f29;
//     text-align: center;
//     line-height: 40px;
// }

// .form-wrapper {
//     margin-top: 5%;
//     margin-left: 10%;
// }

// .el-input {
//     display: block;
//     width: 80%;
//     // margin-bottom: 50px;
//     border: 0;

//     & /deep/ .el-input__inner {
//         border: none;
//         background-color: rgba(1, 15, 41, 0);
//     }

//     border-bottom: 1px solid rgb(128, 125, 125);
//     font-size: calc(20vw * 100 / 1920);
//     outline: none;
// }

// & /deep/ .el-form-item__label {
//     font-size: calc(18vw * 100 / 1920);
//     font-weight: bold;
//     color: black;
// }

// .btn {
//     font-size: calc(20vw * 100 / 1920);
//     border: none;
//     background-image: linear-gradient(to right, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%);
//     color: #fff;
//     text-align: center;
//     font-weight: 550;
//     width: 30%;
//     padding: 15px;
//     margin-top: 4%;
//     margin-left: -3%;
// }

// .btn1 {
//     margin-left: 6%;
//     background-image: linear-gradient(15deg, #13547a 0%, #80d0c7 100%);
// }

// .btn2 {
//     width: 50%;
//     margin-top: 55%;
//     margin-left: 26%;
// }</style>